/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useMemo } from 'react';
import { isEmpty } from 'lodash';
import { CustomSelect } from 'components';
import FeaturedSpreadsheetContext from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import withRequired from 'components/WithRequired';
import withTooltip from 'components/WithTooltip';
import { toString } from 'utilities';
import { UnderlyingSecurityProps } from './UnderlyingSecurity.props';
import { SecurityModel } from '../../../../../api';
import { OptionType } from '../../../../../components/CustomSelect/types';

const UnderlyingSecurity = ({ cell, ...restProps }: UnderlyingSecurityProps) => {
  const { onCommit, onRevert } = restProps;
  const { options: underlyingSecurities = [] } = cell as unknown as { options: SecurityModel[] };
  const { onCellsChanged } = useContext(FeaturedSpreadsheetContext);

  const optionIsListed = useMemo(() => {
    if (Array.isArray(underlyingSecurities)) {
      const isListed = underlyingSecurities.find(item => item.id === cell.value);
      return !!isListed;
    }

    return false;
  }, [underlyingSecurities]);

  const getOptions = useMemo(() => {
    const tmpOptions: OptionType[] = [];

    if (Array.isArray(underlyingSecurities)) {
      Object.entries(underlyingSecurities).forEach(([, { name, id }]) => {
        tmpOptions.push({
          value: id?.toString() ?? '',
          label: name,
        });
      });
    }

    return tmpOptions;
  }, [underlyingSecurities]);

  const handleChange = (value: string | null) => {
    const newValue = toString(value);
    onCellsChanged([{ cell, value: newValue }]);
  };

  return (
    <CustomSelect
      id={`underlying-select-${cell.key}`}
      value={((optionIsListed && cell.value) as string) || ''}
      options={getOptions}
      onChange={handleChange}
      onCommit={onCommit}
      onRevert={onRevert}
      onEmptyValue="SELECT SECURITY"
      disabled={!!cell.readOnly || isEmpty(getOptions)}
    />
  );
};

export default withRequired(withTooltip(UnderlyingSecurity));
